import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsActivitiesComponent } from './settings-activities.component';
import { MaterialModule } from 'src/app/material.module';
import { SituatieCurentaModule } from 'src/app/platform/nomenclatoare/activities-setari/situatie-curenta/situatie-curenta.module';
import { GrupAtributeModule } from 'src/app/platform/nomenclatoare/activities-setari/grup-atribute/grup-atribute.module';
import { AtributeCopiiModule } from 'src/app/platform/nomenclatoare/activities-setari/atribute-copii/atribute-copii.module';
import { TipuriDateModule } from 'src/app/platform/nomenclatoare/activities-setari/tipuri-date/tipuri-date.module';
import { StatusEvenimentModule } from 'src/app/platform/nomenclatoare/activities-setari/status-eveniment/status-eveniment.module';
import { PrioritateEvenimentModule } from 'src/app/platform/nomenclatoare/activities-setari/prioritate-eveniment/prioritate-eveniment.module';
import { EntitateInruditaTypeModule } from 'src/app/platform/nomenclatoare/activities-setari/entitate-inrudita-type/entitate-inrudita-type.module';
import { RelatieTypeModule } from 'src/app/platform/nomenclatoare/activities-setari/relatie-type/relatie-type.module';
import { CustodieTypeModule } from 'src/app/platform/nomenclatoare/activities-setari/custodie-type/custodie-type.module';
import { RelatieStatusModule } from 'src/app/platform/nomenclatoare/activities-setari/relatie-status/relatie-status.module';
import { CapacitateCrestereModule } from 'src/app/platform/nomenclatoare/activities-setari/capacitate-crestere/capacitate-crestere.module';
import { NivelRiscModule } from 'src/app/platform/nomenclatoare/activities-setari/nivel-risc/nivel-risc.module';
import { StatusLegalModule } from 'src/app/platform/nomenclatoare/activities-setari/status-legal/status-legal.module';
import { ContactFrecventaModule } from 'src/app/platform/nomenclatoare/activities-setari/contact-frecventa/contact-frecventa.module';
import { ParteaRelatieiModule } from 'src/app/platform/nomenclatoare/activities-setari/partea-relatiei/partea-relatiei.module';
import { RelatieSpecificaModule } from 'src/app/platform/nomenclatoare/activities-setari/relatie-specifica/relatie-specifica.module';
import { ConfirmareRelatieModule } from 'src/app/platform/nomenclatoare/activities-setari/confirmare-relatie/confirmare-relatie.module';
import { AdreseCentreModule } from 'src/app/platform/nomenclatoare/activities-setari/adrese-centre/adrese-centre.module';
import { ConditieMedicalaModule } from 'src/app/platform/nomenclatoare/activities-setari/conditie-medicala/conditie-medicala.module';
import { EvenimentGenealogicModule } from 'src/app/platform/nomenclatoare/activities-setari/eveniment-genealogic/eveniment-genealogic.module';

@NgModule({
    declarations: [
        SettingsActivitiesComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        SituatieCurentaModule,
        GrupAtributeModule,
        AtributeCopiiModule,
        TipuriDateModule,
        StatusEvenimentModule,
        PrioritateEvenimentModule,
        EntitateInruditaTypeModule,
        RelatieTypeModule,
        CustodieTypeModule,
        RelatieStatusModule,
        CapacitateCrestereModule,
        NivelRiscModule,
        StatusLegalModule,
        ContactFrecventaModule,
        ParteaRelatieiModule,
        RelatieSpecificaModule,
        ConfirmareRelatieModule,
        AdreseCentreModule,
        ConditieMedicalaModule,
        EvenimentGenealogicModule,
    ],
    exports: [SettingsActivitiesComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsActivitiesModule { }
